// extracted by mini-css-extract-plugin
module.exports = {"container":"UserSettings_container__LmH8C"};